// Import API service
import { tellersApi } from '@/services/api'

// Initial state
const state = {
  dashboardStats: null,
  performanceReport: null,
  recentActivity: [],
  loading: false,
  error: null
}

// Getters
const getters = {
  dashboardStats: state => state.dashboardStats,
  performanceReport: state => state.performanceReport,
  recentActivity: state => state.recentActivity,
  isLoading: state => state.loading,
  error: state => state.error
}

// Mutations
const mutations = {
  SET_DASHBOARD_STATS(state, stats) {
    state.dashboardStats = stats
  },
  SET_PERFORMANCE_REPORT(state, report) {
    state.performanceReport = report
  },
  SET_RECENT_ACTIVITY(state, activity) {
    state.recentActivity = activity
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

// Actions
const actions = {
  async fetchDashboardStats({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await tellersApi.getDashboardStats()
      commit('SET_DASHBOARD_STATS', response.data)
      commit('SET_ERROR', null)
    } catch (error) {
      console.error('Error fetching dashboard stats:', error)
      commit('SET_ERROR', 'Failed to load dashboard statistics')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchPerformanceReport({ commit }, params = {}) {
    commit('SET_LOADING', true)
    try {
      const response = await tellersApi.getPerformanceReport(params)
      commit('SET_PERFORMANCE_REPORT', response.data)
      commit('SET_ERROR', null)
    } catch (error) {
      console.error('Error fetching performance report:', error)
      commit('SET_ERROR', 'Failed to load performance report')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchRecentActivity({ commit }, params = {}) {
    commit('SET_LOADING', true)
    try {
      const response = await tellersApi.getRecentActivity(params)
      commit('SET_RECENT_ACTIVITY', response.data.activity || [])
      commit('SET_ERROR', null)
    } catch (error) {
      console.error('Error fetching recent activity:', error)
      commit('SET_ERROR', 'Failed to load recent activity')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async exportTransactions({ commit }, params = {}) {
    commit('SET_LOADING', true)
    try {
      const response = await tellersApi.exportTransactions(params)
      
      // Create download link
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      
      // Generate filename
      const startDate = params.start_date || new Date().toISOString().split('T')[0]
      const endDate = params.end_date || new Date().toISOString().split('T')[0]
      link.download = `teller_transactions_${startDate}_to_${endDate}.xlsx`
      
      // Trigger download
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      
      commit('SET_ERROR', null)
      return { success: true, message: 'Export completed successfully' }
    } catch (error) {
      console.error('Error exporting transactions:', error)
      commit('SET_ERROR', 'Failed to export transactions')
      return { success: false, message: 'Failed to export transactions' }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async refreshAllData({ dispatch }) {
    await Promise.all([
      dispatch('fetchDashboardStats'),
      dispatch('fetchRecentActivity')
    ])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
} 